(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vz-product-main"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){if(!event.target.matches('[data-vz-mobile-add]'))return;const root=event.target.closest('[data-vz-product]');const button=root&&root.querySelector('[data-vz-add]');if(button)button.click();});document.addEventListener('change',function(event){if(!event.target.matches('[data-vz-variant]'))return;const root=event.target.closest('[data-vz-product]');const option=event.target.options[event.target.selectedIndex];const price=root.querySelector('[data-vz-price]');const button=root.querySelector('[data-vz-add]');if(price)price.textContent=option.dataset.price;if(button){const available=option.dataset.available==='true';button.disabled=!available;button.textContent=available?root.dataset.addLabel:root.dataset.soldLabel;}});

  } catch(e) { console.error(e); }
})();
})();
